// extracted by mini-css-extract-plugin
export default {"root":"NavbarFloat_root__jJv6F","column":"NavbarFloat_column__sfiNz","head":"NavbarFloat_head__XBnMG","body":"NavbarFloat_body__8f04m"};